import styled from '@emotion/styled';
import { FONT, COLORS3 as COLORS, utils } from '../../styles/emotion';

export const Container = styled.a`
  display: flex;
  background-color: ${COLORS.WHITE_100};
  padding: 16px 8px;
  text-decoration: none;

  &:hover {
    background-color: ${COLORS.BLACK_005};
    text-decoration: none;
  }
`;

export const IconContainer = styled.div`
  ${utils.circle};
  background-color: ${COLORS.BLACK_005};
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: ${COLORS.BLACK_100};
  ${Container}:hover & {
    background-color: ${COLORS.WHITE_100};
  }
`;

export const TextContainer = styled.div`
  width: 100%;
`;

export const NotificationMessage = styled.p`
  color: ${COLORS.BLACK_100};
  text-decoration: none;
  font-size: ${FONT.FONT_SIZE_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin-bottom: 4px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${Container}:hover & {
    color: ${COLORS.BLACK_075};
  }
`;

export const TimeLabel = styled.div`
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
  line-height: 16px;
  color: ${COLORS.BLACK_050};
`;

const unreadIndicatorSize = '8px';
export const UnreadDot = styled.span`
  ${utils.circle};
  width: ${unreadIndicatorSize};
  height: ${unreadIndicatorSize};
  padding-left: ${unreadIndicatorSize};
  background-color: ${COLORS.BAY_100};
`;
